import {
  icons,
  MenuItem,
  select,
  sizesIcon,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ButtonOption } from "../../model/sponsor";
import { DrawerProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/interfaces/interface";
import { StepProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { SearchFiltersBarProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/components/SearchFiltersBar";
import { UserCardAddNewProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { CardContextMenuAFYProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { themeCore } from "../../assets/themes/theme";
import { viewTypeProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { PaginationInterface } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { CreateUserProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { variantsAvatar } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import { DrawerDragAndDropProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/components/DrawerDragAndDrop";
import logoAffinity from "../../assets/images/logoAffinity.svg";
import { ChangeEvent } from "react";

export const userView: MenuItem[] = [
  {
    active: false,
    icon: {
      icon: icons.List,
    },
    id: "1",
    name: "List",
  },
  {
    active: true,
    icon: {
      icon: icons.GridView,
    },
    id: "2",
    name: "GridView",
  },
];

export const buttonActionOptions: ButtonOption[] = [
  {
    icons: icons.Menu,
    id: "1",
    name: "Modificar",
  },
];

export const buttonActionOptionsList: MenuItem[] = [
  {
    disabled: false,
    id: "1",
    name: "Modificar",
    divider: false,
    icon: {
      color: "#006ac6",
      icon: icons.Edit,
      size: sizesIcon.standard,
    },
  },
];

export const optionsSelect: select[] = [
  {
    id: "1",
    name: "Banesco",
    value: "1",
  },
];

export const viewTypeAfyProps: viewTypeProps = {
  title: "Usuarios",
  titleColor: themeCore.colorsV2.primary,
  bgColorIconButton: "#EBEEF6",
  bgColorIconButtonSelected: "#1D34FE",
  colorIconButton: "#1D34FE",
  colorIconButtonSelected: "#fff",
  titleView: "Vista",
  floatRight: true,
  insurersView: [
    {
      id: "2",
      name: "List",
      active: false,
      icon: {
        icon: icons.TableRows,
      },
    },
    {
      id: "1",
      name: "GridView",
      active: true,
      icon: {
        icon: icons.GridView,
      },
    },
    {
      id: "3",
      name: "tableView",
      active: false,
      icon: {
        icon: icons.TableView,
      },
    },
  ],
};

export const paginationAFYProps: PaginationInterface = {
  showPagination: true,
  titlePagination: "Filas por página",
  countPagination: 125,
  rowsPerPage: 20,
  pagePagination: 1,
  rowsPerPageOption: [20, 25, 50],
  showFirstButton: true,
  showLastButton: true,
};

export const drawerProps: DrawerProps = {
  openDrawer: false,
  view: 4,
  BgBackdrop: themeCore.colors.backgroundLoader,
  BgcCloseButton: themeCore.colors.background,
  colorIcon: themeCore.colors.lightBlue,
  bgColorDrawer: themeCore.colors.background,
  customHeight: "auto",
  img: logoAffinity,
  title: "Crear usuario",
  subTitle: "Crea un nuevo usuario para tu sistema",
  placeholder: "Nombre del usuario",
  titleButton: "Crear",
  onValueApply: () => {},
  onClose: () => {},
};

export const stepsProps: StepProps = {
  steps: [
    {
      label: "",
      icon: <GridCheckCircleIcon />,
    },
  ],
  currentStep: 1,
};

export const searchFiltersBarProps: SearchFiltersBarProps = {
  showSearch: false,
  setShowSearch: () => {},
  SimpleItem: {
    id: "",
    name: "",
    value: "",
  },
  avatarConfig: {
    iconBgColor: themeCore.colorsV2.primary,
    iconAvatar: icons.Search,
    iconColor: "#fff",
    sizeIcon: sizesIcon.standard,
    avatarVariant: variantsAvatar.rounded,
  },
  buttonConfig: {
    titleInputCloseSearch: "Cerrar",
    titleClearButton: "Limpiar",
    titleSearchButton: "Buscar",
    disabledSearchButton: false,
  },
  inputSearchConfig: {
    placeholderTextSearch: "Buscar usuario",
    disabledSearchInput: false,
    onChangeTextSearch: (e: ChangeEvent<HTMLInputElement>) => {
      console.log("onChangeTextSearch", e.target.value);
    },
    onBlurTextSearch: (e: ChangeEvent<HTMLInputElement>) => {
      console.log("onBlurTextSearch");
    },
  },
  filters: [
    {
      id: "role",
      label: "Rol",
      list: [
        {
          id: "1",
          name: "Administrador",
          value: "admin",
          active: false,
        },
        {
          id: "2",
          name: "Agente",
          value: "agent",
          active: false,
        },
      ],
      defaultCheckedItems: [],
      onSelect: () => {},
    },
    {
      id: "sucursal",
      label: "Sucursal",
      list: [
        {
          id: "1",
          name: "Sucursal 1",
          value: "sucursal1",
          active: false,
        },
      ],
      defaultCheckedItems: [],
      onSelect: () => {},
    },
  ],
};

export const userCardAddNewProps: UserCardAddNewProps = {
  backgroundColor: "#fff",
  icon: icons.AddCircle,
  height: "113px",
  iconColor: themeCore.colorsV2.primary,
  fontSizeIcon: "24px",
  heightList: 55,
  title: "Agregar",
  isList: false,
  onClickAdd: () => {},
};

export const cardContextMenuAFYProps: CardContextMenuAFYProps = {
  backgroundColor: themeCore.colors.background,
  height: "113px",
  onClickContextMenu: () => {},
  textDetails: "Agregar",
  heightList: "55px",
  menuItem: [
    {
      disabled: false,
      icon: {
        color: "#006ac6",
        icon: icons.Edit,
        size: sizesIcon.standard,
      },
      id: "1",
      name: "Modificar",
    },
    {
      disabled: false,
      icon: {
        color: "#006ac6",
        icon: icons.DeleteForever,
        size: sizesIcon.standard,
      },
      id: "2",
      name: "Eliminar",
    },
    {
      disabled: false,
      icon: {
        color: "#006ac6",
        icon: icons.PersonAddDisabled,
        size: sizesIcon.standard,
      },
      id: "3",
      name: "Activo / Inactivo",
    },
    {
      disabled: false,
      icon: {
        color: "#006ac6",
        icon: icons.CheckBox,
        size: sizesIcon.standard,
      },
      id: "4",
      name: "Ver Roles",
    },
  ],
};

export const createUserProps: CreateUserProps = {
  formState: {
    firstName: "",
    lastName: "",
    birthDate: "",
    idType: "",
    idNumber: "",
    gender: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    company: "",
    branch: "",
    intermediary: "",
  },
  onFormChange: () => {},
  onSubmit: () => {},
  idTypeOptions: [],
  genderOptions: [],
  companyOptions: [],
  branchOptions: [],
  intermediaryOptions: [],
};

export const drawerRolesListProps: DrawerProps & {
  openDrawer: boolean;
  onClose: () => void;
  paginationProps: {
    count: number;
    pagePagination: number;
    rowsPerPages: number;
    onChangePage: (page: number) => void;
    onChangeRowsPerPage: (rowsPerPage: number) => void;
    rowsPerPageOptions: number[];
  };
  onClickEdit: () => void;
  data: any[];
  columns: any[];
} = {
  openDrawer: false,
  view: 4,
  BgBackdrop: themeCore.colors.backgroundLoader,
  BgcCloseButton: themeCore.colors.background,
  colorIcon: themeCore.colors.lightBlue,
  onValueApply: () => {},
  onClose: () => {},
  paginationProps: {
    count: 10,
    pagePagination: 1,
    rowsPerPages: 10,
    onChangePage: () => {},
    onChangeRowsPerPage: () => {},
    rowsPerPageOptions: [5, 10, 25],
  },
  onClickEdit: () => {},
  data: [],
  columns: [],
};

export const drawerRolesEditProps: DrawerDragAndDropProps = {
  open: false,
  onClose: () => {},
  availableItems: [],
  assignedItems: [],
  onSave: () => {},
  title: "Asignar Permisos",
  subtitle: "Asigna los permisos que deseas asignar al usuario",
  availableTitle: "Permisos Disponibles",
  assignedTitle: "Permisos Asignados",
  availablePlaceholder: "Buscar",
  assignedPlaceholder: "Buscar",
  availableSearch: "",
  assignedSearch: "",
  onAvailableSearchChange: () => {},
  onAssignedSearchChange: () => {},
  filteredAvailable: [],
  filteredAssigned: [],
};
